<template>
<div>
    <div v-show="loading !== 0">
        <ring-loader></ring-loader>
    </div>
    <span v-show="loading === 0">{{ usage }}</span>
</div>
</template>

<script>
import axios from 'axios'
import RingLoader from 'vue-spinner/src/RingLoader.vue'

export default {
  components: {
    RingLoader
  },
  props: {
    mealId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      loading: 0,
      usage: 0
    }
  },
  created() {
    this.loading++
    this.getLastYearUsage()
  },
  methods: {
    async getLastYearUsage() {
      if (this.$parent.groupedData[this.mealId] && typeof(this.$parent.groupedData[this.mealId].usage) !== 'undefined') {
        this.usage = this.$parent.groupedData[this.mealId].usage
        this.loading--
        return
      }
      let url = Routing.generate('last_year_usage', { mealId: this.mealId })
      const response = await axios.get(
        url, {}
      )
      this.usage = response.data
      if (!this.$parent.groupedData[this.mealId]) {
        this.$parent.groupedData[this.mealId] = {}
      }
      this.$parent.groupedData[this.mealId].usage = response.data
      this.loading--
    }
  }
}

</script>
